import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@ps-design-system/components/Checkbox';
import { Text } from '@ps-design-system/components/Text';
import ExternalCalButtonStrings from './strings';

const ExternalCalButton = (props) => {
  const {
    title,
    desc,
    showRecommendedBadge,
    isChecked,
    onClick
  } = props;

  return (
    <button
      className={`ExternalCalButton ${isChecked ? 'ExternalCalButton_black-border' : ''}`}
      onClick={onClick}
    >
      <Checkbox className="ExternalCalButton_checkbox" onCheckedChange={onClick} checked={isChecked}/>
      <div className="ExternalCalButton_text-content-container">
        <div>
          <div className="ExternalCalButton_title-container">
            <Text typeface="body-2-m">
              {title}
            </Text>
            {showRecommendedBadge &&
              <Text typeface="caption-2-m" className="ExternalCalButton_recommended-badge">
                {ExternalCalButtonStrings.recommendedBadge}
              </Text>
            }
          </div>
          <Text typeface="caption-2" className="ExternalCalButton_desc text-gray-600">
            {desc}
          </Text>
        </div>
      </div>
    </button>
  );
};

ExternalCalButton.propTypes = {
  title: PropTypes.node.isRequired,
  desc: PropTypes.node.isRequired,
  showRecommendedBadge: PropTypes.bool,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func
};

export default ExternalCalButton;
